<template>
  <div class="side-bar">
    <div class="item">
      <!-- 只有在请求数据成功并且赋值之后才渲染PieChart组件 -->
      <!-- v-if 解决这个问题，不然的话内容会为空 -->
      <!-- 销售数据饼图 -->
      <PieChart 
        v-if="show"
        key="1"
        idKey='1'
        :title = "selledData.selledTitle"
        :deviceTypes = "selledData.selledDeviceTypes"
        :seriesData = "selledData.selledDeviceData"
        :total = "selledData.selledTotal"
        :ref="refs[0]"
      />
    </div>
    <!-- 库存数据的饼图 -->
    <div class="item">
      <PieChart 
        v-if="show"
        key="2"
        idKey='2'
        :title = "stockData.stockTitle"
        :deviceTypes = "stockData.stockDeviceTypes"
        :seriesData = "stockData.stockDeviceData"
        :total = "stockData.stockTotal"
        :ref="refs[1]"
      />
    </div>
    <!-- <template v-for="(item, index) in pieLists">
      <div :key="index" class="item">
        <PieChart :key="index" :idKey="item"/>
      </div>
    </template> -->
    <div class="item">
      <!-- <h3 class="h3">{{tableTitle}}</h3> -->
      <div class="content-side">
        <template v-for="(item, index) in tableData">
          <div :key="index" class="content-item">
            <h3 class="sub-title">{{item.name}}</h3>
            <p class="num">
              <zx-icon :type="formatIcon(index)"></zx-icon>
              {{item.value}}
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import PieChart from '@/components/common/PieChart'
import config from '@/config'
import checkType from '@/utils/checkDataType'
import bus from '../../bus/bus'
import {mapState} from 'vuex'
export default {
  components: {
    PieChart
  },
  data () {
    return {
      // selledDeviceTypes: [],
      // selledDeviceData: [],
      // stockDeviceTypes: [],
      // stockDeviceData: [],
      // selledTitle: '',
      // stockTitle: '',
      // selledTotal: 0,
      // stockTotal: 0,
      // 表格数据标题
      tableTitle: '',
      tableData: [],
      refs: ['soldPie', 'stockPie']
    }
  },
  computed: {
    show () {
      return this.selledData && this.stockData
    },
    ...mapState(['selledData', 'stockData'])
  },
  // watch: {
  //   selledData () {
  //     // console.log(this.$refs["soldPie"].reloadPie)
  //     // this.$refs["soldPie"].reloadPie
  //     console.log(this.selledData.selledDeviceData)
  //     this.reloadChildPie('soldPie')
  //   },
  //   stockData () {
  //     // console.log(2)
  //     // this.$refs["stockPie"].reloadPie
  //     this.reloadChildPie('stockPie')
  //   }
  // },
  methods: {
    // 获取产品型号
    // formatDeviceTypes (deviceData) {
    //   // 判断数据是否存在且类型必须是数组
    //   // console.log(checkType)
    //   if (checkType.isArray(deviceData) && deviceData) {
    //     // [{name: 'A'}] 提取name对应的值组成新数组
    //     let deviceTypes = []
    //     deviceData.forEach((d) => {
    //       deviceTypes.push(d.name)
    //     })
    //     return deviceTypes
    //   }
    // },
    formatIcon (index) {
      let icons = ['icon-jigou', 'icon-organize', 'icon-kucun', 'icon-link']
      return icons[index]
    },
    // http请求组织设备库存情况
    queryOrgData () {
      // console.log(config.api.device_query_number_url)
      this.$http.get(config.api.home_total_table_url).then((res) => {
        // console.log(res)
        let {code, result, desc} = res
        // 如果请求的结果是成功的，那就整理数据并赋值
        if (code === 0 && desc === 'success' && result) {
          this.tableTitle = result.title
          this.tableData = result.items
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    reloadChildPie() {
      // console.log(this.$refs[name])
      for (let i = 0; i < this.refs.length; i++) {
        if (this.$refs[this.refs[i]]) {
          this.$refs[this.refs[i]].reloadPie()
        }
      }
    }
    // 获取总的统计数据
    // queryTotalTable () {
    //   this.$http.post(config.api.home_device_overView_url, {orgLink: '20,'}).then((res) => {
    //     // console.log(res)
    //      let {code, result, desc} = res
    //     // 如果请求的结果是成功的，那就整理数据并赋值
    //     if (code === 0 && desc === 'success' && result) {
    //       this.selledDeviceTypes = this.formatDeviceTypes(result.charts[0].items)
    //       this.selledDeviceData = result.charts[0].items
    //       this.selledTotal = result.charts[0].totalNum
    //       this.selledTitle = result.charts[0].title
    //       this.stockDeviceData = result.charts[1].items
    //       this.stockDeviceTypes = this.formatDeviceTypes(result.charts[1].items)
    //       this.stockTotal = result.charts[1].totalNum
    //       this.stockTitle = result.charts[1].title
    //     }
    //   })
    // }
  },
  mounted () {
    bus.$on('onChange', (ev) => {
      // console.log(ev)
      if (ev) {
        this.reloadChildPie()
      }
    })
    bus.$on('windowResize', (ev) => {
      if (ev) {
        for (let i = 0; i < this.refs.length; i++) {
          if (this.$refs[this.refs[i]]) {
            this.$refs[this.refs[i]].pie.resize()
          }
        }
      }
    })
    
  },
  created () {
    this.queryOrgData()
    // this.queryTotalTable()
  }
}
</script>
<style lang="less" scoped>
.side-bar {
  // margin-top: 10px; 
  display: flex;
  height: 88vh;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .item {
    // flex: 1;
    // background: red;
    width: 100%;
    height: 29vh;
    // height: 200px;
    margin: 0 auto 10px;
    box-sizing: border-box;
    border-radius: 3px;
    // border: 1px solid rgb(172, 153, 153);
    box-shadow: 0 1px 10px rgb(129, 120, 120); 
    background-color: rgb(255, 255, 255);
    padding: 10px;
    .h3 {
      text-align: center;
    }
    .content-side {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      grid-gap: 10px;
      margin-top: 20px; 
      .content-item {
        // background-color: rgba(245, 236, 236, 0.596);
        height: 10vh;
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        .sub-title {
          // font-size: 1.1rem;
          margin: 0;
        }
        .num {
          font-size: 2rem;
        }
      }
    }
  }
}
</style>

